import React from 'react';
import { useOffWorldLiveStream } from '../components/OffWorldLiveStreamProvider';
export const useSendReaction = () => {
    const stream = useOffWorldLiveStream();
    return React.useCallback((reactionName) => {
        stream.sendReaction(reactionName);
    }, [stream]);
};
